import { Button, CloseIcon, ProviderConsumer } from "@fluentui/react-northstar";
import React from "react";
import { getFileIcon } from "../../EditTicketAttachments/NewAttachmentFlow/NewAttachmentFlowContent";

export type EditTicketAttachmentsProps = {
  DownloadUrl: string;
  DriveItemGroupId?: string;
  DriveId?: string;
  DriveItemId: string;
  MoveItemFailed: boolean;
  TicketId: number;
  FileCommentId: number;
  IsPublic: boolean;
  ThumbnailUrl: string;
  HasComment: boolean;
  UploadError: boolean;
  FileName: string;
  FileSize: number;
  FileExtension: string;
  IsImage: boolean;
  Id: number;
  ModifiedDate: string;
  ModifiedById: number;
  CreatedDate: string;
  CreatedById: number;
  Guid: string;
  IsDeleted: boolean;
  onRemove?: () => void;
  disabled: boolean;
};

const EditableTicketAttachment: React.FC<EditTicketAttachmentsProps> = (
  props
) => {
  return (
    <ProviderConsumer
      render={(globalTheme) => {
        return (
          <div className="w-1/2 md:w-1/4 p-2">
            <div className="shadow-sm border overflow-hidden rounded-md" style={{backgroundColor: globalTheme.siteVariables.colorScheme.default.background}}>
              {props.IsImage ? (
                <div 
                  style={{
                    backgroundImage: `url(${props.ThumbnailUrl})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    width: '100%',
                    aspectRatio: '16/9',
                    minHeight: '120px'
                  }}
                />
              ) : (
                <div className="flex items-center justify-center" style={{ padding: '1rem', minHeight: '120px' }}>
                  {getFileIcon(props.FileExtension, props, globalTheme)}
                </div>
              )}
              <div className="flex min-w-0 items-center">
                <div
                  className="min-w-0 flex-1 truncate px-2"
                  title={props.FileName}
                >
                  {props.FileName}
                </div>
                <div className="shrink-0">
                  <Button
                    icon={<CloseIcon />}
                    text
                    iconOnly
                    title="Remove"
                    onClick={props.onRemove}
                    disabled={props.disabled}
                  />
                </div>
              </div>
            </div>
          </div>
        );
      }}
    />
  );
};

export default EditableTicketAttachment;
